export default __webpack_public_path__ + "static/media/abardo.c1761d0c.png";